

































import { Component, Watch, Vue } from 'vue-property-decorator';
import Route from 'vue-router';
import ListReports from '@/components/ListReports.vue'; // @ is an alias to /src

// model
import { Report } from '../models/report'

// service
import { Datasource } from '../services/datasource';

@Component({
  components: {
    ListReports,
  },
})
export default class Reports extends Vue {
  page:number = -1
  reports:Report[] = []
  source:Datasource = Datasource.shared  
  pageSize:number = 30
  total:number = 0

  // Computed
  get lastPage() {
    return Math.ceil(this.total / this.pageSize)
  }

  mounted() {
    this.page = +(this.$route.params.id || 0)
  }

  gotoPage(page:number) {
    this.$router.push('/reports/' + page)
  }

  gotoNextPage() {
    this.gotoPage(Math.min(this.lastPage, +this.page + 1))
  }

  gotoPreviousPage() {
    this.gotoPage(Math.max(0, +this.page - 1))
  }

  onEdit(reportId:string) {
    this.$router.push('/report/' + reportId)
  }

  onPrint(reportId:string) {
    this.$router.push('/report/' + reportId + '/print')
  }

  onDelete(reportId:String) {
    // Introduce confirmation dialog
    if (window.confirm(`Are you sure you want to delete Report#${reportId}`)) {
      this.source.deleteReport(+reportId)
        .then((reportId:number) => {
          // reload the UI
          this.onPageChanged(this.page, this.page)
          console.info(`Report #${reportId} has been deleted.`)
        })
        .catch(console.error)
    }
  }

  @Watch('$route')
  onRouteUpdate(val:Route, newVal:Route) {
    this.page = +(this.$route.params.page || 0)
  }

  @Watch('page')
  onPageChanged(val:number, newVal:number) {
    console.log('page changed from', val, 'to', newVal)
    this.source.reports((val || 0) * this.pageSize, this.pageSize)
      .then(([reports, total]) => {
        this.reports = reports;
        this.total = total;
      })
      .catch(console.error)
  }
}
